import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AuthedDirective, UnauthedDirective } from '@directives';
import { AuthService } from '@services';
import { DesignatedApproverDirective } from '@shared/directives/designated-approver.directive';
import { AppHeaderProductSelectComponent } from '../app-header-product-select/app-header-product-select.component';
import { AppHeaderSearchBarComponent } from '../app-header-search-bar/app-header-search-bar.component';
import { AppHeaderComponent } from '../app-header.component';
import { MegaMenuSection } from '../app-mega-menu/app-mega-menu.component';

@Component({
    selector: 'app-header-mobile',
    standalone: true,
    imports: [
        CommonModule,
        AppHeaderProductSelectComponent,
        AppHeaderSearchBarComponent,
        AuthedDirective,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        RouterModule,
        UnauthedDirective,
        DesignatedApproverDirective,
    ],
    templateUrl: './app-header-mobile.component.html',
    styleUrls: ['./app-header-mobile.component.scss'],
})
export class AppHeaderMobileComponent {
    parent = inject(AppHeaderComponent);
    private authService = inject(AuthService);

    @Input() breakpointClass: string = 'mobile';

    // Mobile-specific properties
    isMobileMenuOpen = false;
    activeSubmenu: string | null = null;

    /**
     * Toggle mobile menu open/close
     */
    toggleMobileMenu(): void {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
        document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : '';
    }

    /**
     * Mobile-specific menu methods
     * @param label - active submenu item label
     */
    toggleSubmenu(label: string) {
        this.activeSubmenu = this.activeSubmenu === label ? null : label;
    }

    /**
     * Close mobile menu and reset submenu
     */
    closeMobileMenu(): void {
        this.isMobileMenuOpen = false;
        document.body.style.overflow = '';
    }

    /**
     * Handle mobile navigation event click
     */
    handleMobileNavClick(): void {
        this.closeMobileMenu();
        this.activeSubmenu = null;
        this.parent.scrollToTop();
    }

    /**
     * Handle spotlight button action (e.g. sign-in)
     * @param section - MegaMenuSection
     */
    handleSpotlightAction(section: MegaMenuSection): void {
        this.closeMobileMenu();
        if (section.content?.buttonAction === 'signIn') {
            this.authService.signInWithRedirect();
        }
    }
}
